import '@hotwired/turbo-rails';
import { Application } from '@hotwired/stimulus';
import Alpine from 'alpinejs';
import ImagesLoaded from 'imagesloaded';
import './src/utils/dialog';

import StartController from './src/controllers/sharing_station/start_controller';
import ResetController from './src/controllers/sharing_station/reset_controller';
import CableController from './src/controllers/sharing_station/cable_controller';
import DisclaimerController from './src/controllers/sharing_station/disclaimer_controller';
import TurbomodalController from './src/controllers/sharing_station/turbomodal_controller';
import SurveyController from './src/controllers/sharing_station/survey_controller';
import OfflineController from './src/controllers/sharing_station/offline_controller';
import NumberControlsController from './src/controllers/sharing_station/number_controls_controller';

import EmailShareDialog from './src/sharing_station/email_share_dialog';
import SmsShareDialog from './src/sharing_station/sms_share_dialog';
import Alert from './src/sharing_station/alert';

document.addEventListener('turbo:before-stream-render', async (event) => {
  event.preventDefault();
  const timeStart = Date.now();
  const spinner = document.getElementById('spinner');
  if (spinner) spinner.classList.add('spin');
  const clone = event.detail.newStream.firstChild.content.cloneNode(true);
  ImagesLoaded(clone, () => {
    const timeEnd = Date.now();
    const timeDiff = (timeEnd - timeStart) / 1000;
    if (timeDiff > 10 && document.cookie.indexOf('slow=1') === -1) {
      const { eventId } = document.body.dataset;
      const platform = 'PicPic Share (Virtual)';
      if (window.confirm('It looks like your internet connection is slow. Would you like to switch to fast mode? It will be active for an hour. Alternatively, please use faster internet connection.')) {
        document.cookie = 'slow=1; max-age=3600';
        if (window.mixpanel) {
          window.mixpanel.track('Slow Mode Accepted', {
            platform,
            eventId,
          });
        }
      } else {
        document.cookie = 'noslow=1; max-age=3600';
        if (window.mixpanel) {
          window.mixpanel.track('Slow Mode Rejected', {
            platform,
            eventId,
          });
        }
      }
    }
    event.detail.render(event.detail.newStream);
    if (spinner) spinner.classList.remove('spin');
  });
});

document.addEventListener('turbo:frame-missing', async (event) => {
  event.preventDefault();
  console.log('frame-missing', event);
  window.alert('An error has occurred. Please try again.');
});

document.addEventListener('alpine:init', () => {
  Alpine.data('shareDialog', EmailShareDialog);
  Alpine.data('smsShareDialog', SmsShareDialog);
  Alpine.data('alert', Alert);
});

const application = Application.start();

application.register('start', StartController);
application.register('reset', ResetController);
application.register('cable', CableController);
application.register('disclaimer', DisclaimerController);
application.register('turbomodal', TurbomodalController);
application.register('survey', SurveyController);
application.register('offline', OfflineController);
application.register('number-controls', NumberControlsController);

document.body.addEventListener('click', () => {
  if ('wakeLock' in navigator) {
    const requestWakeLock = async () => {
      try {
        await navigator.wakeLock.request('screen');
      } catch (err) {
        console.log(`${err.name}: ${err.message}`);
      }
    };

    requestWakeLock();
  }
}, { once: true });

window.Alpine = Alpine;
Alpine.start();

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/serviceworker.js');
}
